<template>
  <div>
    {{ VSpeed }} 
    <span class="text-xs">{{ $e("V/s") }}</span>
  </div>
</template>

<script>
export default {
  props: {
    config: Object,
  },
  computed: {
    VSpeed() {
      return this.config?.drone?.status?.vertical_speed != undefined
        ? parseFloat(this.config.drone?.status.vertical_speed).toFixed(1)
        : ENV.NO_DATA;
    },
  },
};
</script>
